/**
 * Serialize a JSON-LD value for embedding inside a
 * `<script type="application/ld+json">` block.
 *
 * `innerHTML` does not HTML-escape its content, so a value containing
 * `</script>` (for example CMS-authored FAQ text, which stripMarkdown turns
 * back into raw angle brackets) could otherwise terminate the script element
 * early. Escaping `<` as its JSON unicode escape keeps the payload valid
 * JSON-LD while making it impossible to break out of the script tag.
 */
export function serializeJsonLd(value: unknown): string {
  return JSON.stringify(value).replace(/</g, '\\u003c');
}
